import { loginByUsername, logout, getUserInfo } from '@/api/login'
import userInfoAPI from '@/api/api'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { asyncRouterMap, constantRouterMap } from '@/router'
import ElementUI from "element-ui";
const user = {
  state: {
    user: '',
    status: '',
    code: '',
    token: '',
    name: '',
    avatar: '',
    introduction: '',
    role_id:'',
    roles: [],
    role_permission:[],
    setting: {
      articlePlatform: []
    }
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_INTRODUCTION: (state, introduction) => {
      state.introduction = introduction
    },
    // SET_SETTING: (state, setting) => {
    //   state.setting = setting
    // },
    // SET_STATUS: (state, status) => {
    //   state.status = status
    // },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_role_id: (state, name) => {
      state.role_id = name
    },
    SET_permission: (state, name) => {
      state.role_permission = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      let list={
        user_phone:userInfo.username,
        user_password:userInfo.password
      }
      return new Promise((resolve, reject) => {
        userInfoAPI.logout(list).then(response => {
		  if(response.data.code == 0){
			commit('SET_TOKEN', response.data.data.api_token)
			commit('SET_AVATAR', response.data.data.photo_path)
			setToken(response.data.data.api_token)
			resolve()  
		  }else{
			reject()
		  }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        userInfoAPI.getUserInfo().then(response => {
          // 由于mockjs 不支持自定义状态码只能这样hack
          if (!response.data) {
            reject('Verification failed, please login again.')
          }
          const res = response.data.data
          if (res.role_name ) { // 验证返回的roles是否是一个非空数组
            let role = [];
            role.push(res.role_name)
			if(res.role_id == 1) role = ['admin']
            commit('SET_ROLES', role)
          } else {
            reject('getInfo: roles must be a non-null array!')
          }
          userInfoAPI.adminRole(res.role_id).then(({data})=>{
            if(data.code==0){
              let list = data.data.role_permission;
              let listname = data.data.role_name;
              let fal=false;
              list.forEach(element => {
                asyncRouterMap.forEach(itme=>{
                  if(itme.children && itme.children.length>0){
                    itme.children.forEach(index=>{
                      if(index.path === element.path){
                        index.meta.roles.push(listname);
                      }
                    })
                  }
                })
              });
              commit('SET_permission', list)
              commit('SET_role_id', data.role_id)
              commit('SET_NAME', data.data.name)
              // commit('SET_AVATAR', data.photo_path||'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
              commit('SET_INTRODUCTION', listname)
              resolve(response)
            }else{
              commit('SET_TOKEN', '')
              removeToken()
              resolve()
              ElementUI.Message ({
                showClose: true,
                message: data.msg,
                type: 'error'
              });
            }
          })
        }).catch(error => {
          reject(error)
        })
      })
    },


    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
      })
    },
	
	setAvatar({
		commit
	}, avatar, name) {
		commit('SET_AVATAR', avatar)
		if(name) commit('SET_NAME', name)
	},
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    ChangeRoles({ commit, dispatch }, role) {
      return new Promise((resolve, reject) => {
        userInfoAPI.getUserInfo().then(response => {
          // 由于mockjs 不支持自定义状态码只能这样hack
          const datalist = response.data.data
          let role = [];
          role.push(datalist.role_name)
          
          
          userInfoAPI.adminRole(datalist.role_id).then(({data})=>{
            let list=data.data.role_permission;
            let listname=data.data.role_name;
            let fal=false;
            list.forEach(element => {
              asyncRouterMap.forEach(itme=>{
                if(itme.children&&itme.children.length>0){
                  itme.children.forEach(index=>{
                    index.meta.roles=[];
                    if(index.path===element.path){
                      index.meta.roles.push(listname);
                    }
                  })
                }
              })
            });
            let roles = datalist.role_name;
              commit('SET_permission', list)
              commit('SET_role_id', datalist.role_id)
              commit('SET_NAME', datalist.name)
              // commit('SET_AVATAR', datalist.photo_path||'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
              commit('SET_INTRODUCTION', datalist.name)
			  if(datalist.role_id == 1) roles = 'admin'
              dispatch('GenerateRoutes', {roles}) // 动态修改权限后 重绘侧边菜单
			  commit('SET_ROLES', [roles])
              resolve(response)
          })
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user
